export default {"src":"/_next/static/media/carHalfcircled_24.7e87b4d6.svg","height":24,"width":24,"blurWidth":0,"blurHeight":0};